import dynamic from 'next/dynamic';
import { MemberInformationProps } from './MemberInformation.types';
import { UserInformationProps } from './V2/index.types';

export const MemberInformationMGP = dynamic<MemberInformationProps>(() => import('./MemberInformation'));

export const MemberInformationV2MGP = dynamic<UserInformationProps>(() =>
  import('./V2').then(module => module.MemberInformationV2)
);
